import React, { useRef } from "react";
import SalesStatisticOne from "../components/SalesStatisticOne";
import EmployeeDashboardData from "./EmployeeDashboardData";
import UnitCountOne from "../components/UnitCountOne";
import FacilityDataTable from "./FacilityDataTable";
import DocumentDataTable from "./DocumentDataTable";
import DailyAdminAttendance from "./DailyAdminAttendance";

const DashBoardLayerOne = () => {
  // Create a ref to access DailyAdminAttendance methods
  const attendanceRef = useRef();

  return (
    <>
      {/* UnitCountOne */}
      <UnitCountOne />

      <section className="row gy-4 mt-1 mb-4">
        {/* SalesStatisticOne */}
        <SalesStatisticOne />
      </section>

      <section className="row gy-4 mt-4">
        <div className="col-12">
          <h2 className="fs-2">Employees</h2>
          <EmployeeDashboardData />
        </div>
      </section>

      <section className="row gy-4 mt-4">
        <div className="col-12">
          <h2 className="fs-2">Documents</h2>
          <DocumentDataTable />
        </div>
      </section>

      <section className="row gy-4 mt-4">
        <div className="col-12">
          <h2 className="fs-2">Facility Attendance</h2>
          <DailyAdminAttendance ref={attendanceRef} />
        </div>
      </section>

      <section className="row gy-4 mt-4">
        <div className="col-12">
          <h2 className="fs-2">Facilities</h2>
          {/* LatestRegisteredOne */}
          <FacilityDataTable />
        </div>
      </section>
    </>
  );
};

export default DashBoardLayerOne;
